import { render, staticRenderFns } from "./report_stu2.vue?vue&type=template&id=0fb50279&scoped=true&"
import script from "./report_stu2.vue?vue&type=script&lang=js&"
export * from "./report_stu2.vue?vue&type=script&lang=js&"
import style0 from "./report_stu2.vue?vue&type=style&index=0&id=0fb50279&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb50279",
  null
  
)

export default component.exports